// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3136) return "static/chunks/3136.90d676540f5a879a.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"108":"95d0459c","5046":"5dd176c9"}[chunkId] || chunkId) + "-" + {"108":"4a712e796d042141","589":"938b4a768d0d53d5","5046":"28be1a9daa56d095"}[chunkId] + ".js";
};